import { stringifyQueryString } from '@_/utils';
import { getFileMimeType } from './fileUtil.ts';

export function dynamicImageUrl(
  src: string,
  opt: {
    contain?: boolean;
    format?: 'jpeg' | 'webp';
    width?: number;
    height?: number;
  }
): string {
  const { contain, format = 'jpeg', width, height } = opt || {};

  const queryString = stringifyQueryString({
    c: contain === true ? '1' : undefined,
    w: width,
    h: height
  });

  return `${src}.${format}?${queryString}`;
}

export async function createImageObjectUrl(blob: Blob) {
  let imageBlob = blob;

  const mime = await getFileMimeType(blob);
  if (mime === 'image/heic' || mime === 'image/heif') {
    imageBlob = await convertHeicToJpeg(blob);
  }

  return URL.createObjectURL(imageBlob);
}

export async function convertHeicToJpeg(blob: Blob) {
  const heicConvert = await import('heic-convert/browser');
  const result = await heicConvert.default({
    buffer: new Uint8Array(await blob.arrayBuffer()),
    format: 'JPEG',
    quality: 0.5
  });
  return new Blob([result.buffer as ArrayBuffer]);
}

export async function getImageDimensions(
  objectUrl: string
): Promise<{ width: number; height: number } | undefined> {
  return new Promise(resolve => {
    const image = new Image();

    image.onload = () => {
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight
      });
    };

    image.onerror = () => {
      resolve(undefined);
    };

    image.src = objectUrl;
  });
}
